import React from "react";
import { useState,useEffect } from "react";
import SalespersonSidebar from "./SalespersonSidebar";
import Editor from 'react-simple-wysiwyg';
import { Helmet } from "react-helmet";
import './classes/ResourceLibraryCreate.css';
import { useParams } from 'react-router-dom';
import { Link, useNavigate,useLocation  } from 'react-router-dom';
import { configData } from "../config";
import Loading from './Loading';

const ResourceLibraryCreate = () => {

    
 
    const initialFormData = {
        title:'',
        field_folder:0,
        summary: '',
        body: '',
        field_url:'',
        field_file_attachments:[],
        field_meta_title:'',
        field_meta_keywords:'',
        field_meta_description:'',
        button_name:'Save',
    };

    const [formData,setFormData] =useState(initialFormData);
    const [isLoading, setIsLoading] = useState(true);
    const [errors, setErrors] = useState({});
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [fileInputKey, setFileInputKey] = useState(0);
    const [errorMessage, setErrorMessage] = useState('');
    const [showSummary, setShowSummary] = useState(false);
    const [useRichEditor, setUseRichEditor] = useState(true);
    const [PreviewFields, setPreviewFields] = useState(false);
    const [previewData, setPreviewData] = useState(null);
    const [folders, setFolders] = useState({});
    const location  = useLocation();
    const drupal_uid = localStorage.getItem('drupal_uid');
    const drupal_domain_url = configData.DRUPAL_DOMAIN_URL;
    var loggedin_domain = drupal_domain_url;
    if(localStorage.getItem('loggedin_domain')) {
    loggedin_domain = localStorage.getItem('loggedin_domain');
    } 
    var {uid} = useParams();
    var {username} = useParams();
    if(location.state) {
    uid = location.state;
    }
    const {tab} = useParams();
    const loggedin_uid = localStorage.getItem('uid');
    const navigate = useNavigate();
    const app_url = configData.APP_URL;
    const domain_url = configData.DOMAIN_URL;

    const [disabled, setDisabled] = useState(false);

    useEffect(() => {
                         Promise.all([
                 
                  getresourcelibraryfolderlist()
                  ]).then(() => {
             
                    setIsLoading(false);
                   
                  })
                        }, []);
     async function getresourcelibraryfolderlist() {
    
        try {
      
            const response = await fetch(
                app_url+'smwwagency/getresourcelibraryfolderlist',
                {
                    method: "GET",
  
                    headers: {
                        'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data) {
                setFolders(responsedata.data.result);
               
            } 
        } catch (error) {
        console.error(error);
      }finally {
            
          }
        
  }

    // const handlePreviewRedirect = () => {
    //     if (previewData.field_folder_id === 0) {
    //     navigate('/resource_library');
    //     } else {
    //     navigate('/resource_library?tid='+previewData.field_folder_id);
    //     }
    // };
    const getFolderLabel = (value) => {
    if (!Array.isArray(folders)) return value;

    const match = folders.find(f => String(f.value) === String(value));

    return match ? match.label : value;
    };

const handlePreviewClick = () => {
    const {
        title,
        field_folder,
        summary,
        body,
        field_url,
        field_file_attachments,
        field_meta_title,
        field_meta_keywords,
        field_meta_description
    } = formData;

    const newErrors = {};
    if (!title.trim()) {
        newErrors.title = "Title field is required.";
        window.scrollTo(0, 0);
    }

    if (Object.keys(newErrors).length > 0) {
        setErrors(newErrors);
        setPreviewFields(false);
        return;
    }

    const cleanedSummary = cleanHtmlOutput(summary);
    const cleanedBody = cleanHtmlOutput(body);

    const hasSummary = cleanedSummary && cleanedSummary.trim() !== '';
    let trimmedHtml = '';

    if (hasSummary) {
        trimmedHtml = cleanedSummary;
    } else if (cleanedBody.includes('<!--break-->')) {
        trimmedHtml = cleanedBody.split('<!--break-->')[0];
    } else {
        const tmp = document.createElement('div');
        tmp.innerHTML = cleanedBody;
        // const plainText = (tmp.textContent || tmp.innerText || "").trim();

        // let snippet = plainText.split('. ')[0];
        // if (snippet.length < 20) {
        //     snippet = plainText.substring(0, 200);
        // }

        // trimmedHtml = snippet ? `<p>${snippet}</p>` : '';
        trimmedHtml = '';
    }

    setPreviewData({
        title,
        field_folder_id: formData.field_folder,
        field_folder: getFolderLabel(formData.field_folder),
        summary: hasSummary ? cleanedSummary : '',
        trimmed: trimmedHtml,
        body: cleanedBody,
        field_url,
        field_file_attachments,
        field_meta_title,
        field_meta_keywords,
        field_meta_description
    });

    setErrors({});
    setPreviewFields(true);
    window.scrollTo(0, 0);
};

    const cleanHtmlOutput = (html) => {
        if (!html || typeof html !== 'string') return '';

        let cleaned = html;

        cleaned = cleaned.replace(/<\s*(p|div|h[1-6])[^>]*>\s*(<br\s*\/?>|\&nbsp;|\s)*\s*<\/\1\s*>/gi, '');

        cleaned = cleaned.replace(/<br\s*\/?>/gi, '');

        const textOnly = cleaned.replace(/&nbsp;|\s|<[^>]*>/g, '').trim();

        return textOnly.length === 0 ? '' : cleaned.trim();
    };

    const handleEditorChange = (e) => {
        setFormData(prev => ({
            ...prev,
            body: e.target.value
        }));
    };
      

    const getFileIcon = (fileName) => {
        const extension = fileName.split('.').pop().toLowerCase();

        switch (extension) {
            case 'txt':
            return '/basic/web/images/text-plain.png';
            case 'pdf':
            return '/basic/web/images/application-pdf.png';
            case 'docx':
            return '/basic/web/images/x-office-document.png';
            case 'jpg':
            case 'jpeg':
            return '/basic/web/images/image-x-generic.png';
            case 'xls':
            case 'xlsx':
            return '/basic/web/images/x-office-spreadsheet.png';
            case 'csv':
            return '/basic/web/images/text-x-generic.png';
            case 'mp4':
            return '/basic/web/images/video-x-generic.png';
            case 'png':
            return '/basic/web/images/image-x-generic.png';
            default:
            return '/basic/web/images/image-x-generic.png';
        }
    };

    const maxSize = 128 * 1024 * 1024;

    const handleFileInputChange = (e) => {
        const files = Array.from(e.target.files);

        const allowedMimeTypes = [
            'text/plain',
            'application/msword',
            'application/pdf',
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'text/csv',
            'text/html',
            'image/gif',
            'image/png',
            'image/jpeg',
            'video/mp4',
            'video/quicktime',
            'video/x-flv'
        ];

        const validFiles = [];
        const invalidFiles = [];

        files.forEach(file => {
            const isValidSize = file.size <= maxSize;
            const isValidType = allowedMimeTypes.includes(file.type);

            if (isValidSize && isValidType) {
                validFiles.push(file);
            } else {
                invalidFiles.push(file);
            }
        });

        if (invalidFiles.length > 0) {
            const names = invalidFiles.map(f => f.name).join(', ');
            setErrorMessage(
            `The selected file${invalidFiles.length > 1 ? 's' : ''} ${names} cannot be uploaded.
              Only files with the following extensions are allowed: txt, doc, pdf, xls, docx, xlsx, csv, html, htm, gif, png, jpg, mp4, mov, flv.`
            );
            setFileInputKey(prev => prev + 1);
            setSelectedFiles([]);
        } else {
            setErrorMessage('');
            setSelectedFiles(validFiles);
        }
    };

    const handleUpload = () => {
        // Validate selected files
        const newFiles = selectedFiles.filter(file => {
         
            const isValidSize = file.size <= maxSize;
            return isValidSize;
        });

        setUploadedFiles(prev => [...prev, ...newFiles]);
         setFormData(prev => ({
        ...prev,
        field_file_attachments: [...prev.field_file_attachments, ...newFiles]
    }));
        setErrorMessage('');
        setSelectedFiles([]);
        
        // Clear input value by resetting key prop or manually
        // document.getElementById('edit-field-agent-contract').value = '';
        setFileInputKey(prev => prev + 1);
    };

    const removeFile = (index) => {
        setUploadedFiles(prev => prev.filter((_, i) => i !== index));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };
    
    const validateForm = () => {
        const newErrors = {};
        if (!formData.title.trim()) {
            newErrors.title = "Title is required.";
        }
        return newErrors;
    };

    const inputStyle = {
        title: {
            border: errors.title ? '2px solid red' : '1px solid #777'
        },
    };
    
    

    const handleSubmit = async (e) => {
        e.preventDefault();

        const validationErrors = validateForm();
        setErrors(validationErrors);

        if (Object.keys(validationErrors).length > 0) return;

        const cleanedSummary = cleanHtmlOutput(formData.summary);
        const cleanedBody = cleanHtmlOutput(formData.body);
        const postData = new FormData();
        const updatedFormData = {
            ...formData,
           summary: cleanedSummary,
            body: cleanedBody,
        };
        setFormData(prevState => ({
            ...prevState,
            button_name: "Saving..."
        }));
        setDisabled(true);
        postData.append('file', selectedFiles);
        uploadedFiles.forEach(file => postData.append('files[]', file));
        // postData.append('formData', JSON.stringify(formData));
        postData.append('formData', JSON.stringify(updatedFormData));
        const response = await fetch(app_url+'smwwagency/addresourcelibrary', {
            method: 'POST',
            body: postData,
        });
        const data = await response.json();
        if(data.data.msg == "Success") { 
            setFormData(prevState => ({
                ...prevState,
                button_name: "Save"
            })); 
            setDisabled(false);
            navigate('/resource_library/'+data.data.id+'/view', { state: { message: data.data.result } });
        } 
       
     

        // API call or logic
    };

    return (
        <>
            {isLoading ? (
                <Loading />
            ) : (
                <div id="main">
                    <Helmet>
                        <title>
                            Create Resource Library
                        </title>
                    </Helmet>
                    <div className="left"></div>
                    <div className="center left-center">
                        <div className="resource-library-create-preview">
                            {PreviewFields && (
                            <>
                                <div
                                    className="messages status"
                                    style={{
                                        background: `#f0f8eb url("/basic/web/images/message-ok.png") no-repeat`,
                                        backgroundPosition: '10px 10px',
                                    }}
                                >
                                    The trimmed version of your post shows what your post looks like when promoted
                                    to the main page or when exported for syndication.
                                    <span>
                                        You can insert the delimiter &lt;!--break--&gt; (without the quotes) to
                                        fine-tune where your post gets split.
                                    </span>
                                </div>

                                <div className="preview-container">
                                    {/* Trimmed version */}
                                    <div className="preview-trimmed">
                                        <h4 className="preview-heading">
                                            Preview trimmed version
                                        </h4>

                                        <div className="email-teaser">
                                            <h2 className="email-title">
                                                <span>{previewData?.title}</span>
                                            </h2>

                                            {(previewData.summary?.trim() || previewData.body?.includes('<!--break-->') || previewData.trimmed) && (
                                                <div
                                                    className="preview-body-content"
                                                    dangerouslySetInnerHTML={{ __html: previewData.trimmed }}
                                                />
                                            )}

                                            {/* <div className="read-more-link">
                                                <a href="/full-email-Viewpage">Read more</a>
                                            </div> */}
                                        </div>
                                    </div>

                                    {/* Full version */}
                                    <div className="preview-full">
                                        <h4 className="preview-heading">
                                            Preview full version
                                        </h4>

                                        <div className="email-teaser">
                                            <h2 className="email-title">
                                                {/* <strong>Body:</strong> */}
                                            </h2>

                                            <div
                                                dangerouslySetInnerHTML={{
                                                __html: previewData.body || '',
                                                }}
                                            />
                                            <div className="email-meta">
                                                {previewData.field_folder && (
                                                    <p><strong>Folder:</strong> {previewData.field_folder}</p>
                                                )}
                                                {previewData.field_url && (
                                                    <p><strong>URL:</strong> {previewData.field_url}</p>
                                                )}
                                                {previewData.field_file_attachments && previewData.field_file_attachments.length > 0 && (
                                                    <>
                                                        <strong>File Attachments:</strong>
                                                        <ul>
                                                        {previewData.field_file_attachments.map((file, idx) => (
                                                            <li key={idx}>
                                                                <span className="file">
                                                                    <img
                                                                        className="file-icon"
                                                                        alt="File icon"
                                                                        src={getFileIcon(file.name)}
                                                                        style={{ marginRight: '8px' }}
                                                                    />
                                                                    <a href={URL.createObjectURL(file)} target="_blank" rel="noreferrer">
                                                                    {file.name}
                                                                    </a>
                                                                </span>
                                                                ({(file.size / 1024).toFixed(2)} KB)
                                                            </li>
                                                        ))}
                                                        </ul>
                                                    </>
                                                )}
                                                {previewData.field_meta_title && (
                                                    <p><strong>Meta Title:</strong> {previewData.field_meta_title}</p>
                                                )}
                                                {previewData.field_meta_keywords && (
                                                    <p><strong>Meta Keywords:</strong> {previewData.field_meta_keywords}</p>
                                                )}
                                                {previewData.field_meta_description && (
                                                    <p><strong>Meta Description:</strong> {previewData.field_meta_description}</p>
                                                )}
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </>
                            )}
                        </div>
                        <div className="resource-library-create-container">
                            {Object.values(errors).some(msg => !!msg) && (
                                <div
                                    className="set-message-error error-message-padding"
                                    style={{
                                    background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 7px no-repeat`
                                    }}
                                >
                                    <ul>
                                    {Object.values(errors)
                                        .filter(msg => !!msg)
                                        .map((msg, index) => (
                                        <li key={index}>{msg}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                            <form onSubmit={handleSubmit}>
                                <div>
                                    <div className="form-item">
                                        <label htmlFor="create-agent-message-title">
                                            Title  
                                            <span className="form-required" title="This field is required.*">*</span>
                                        </label>
                                        <input 
                                            className="create-agent-message-title-field" 
                                            type="text" 
                                            id="create-agent-message-title" 
                                            name="title" 
                                            maxLength={100}
                                            onChange={handleChange} 
                                            style={inputStyle.title}
                                        />
                                    </div>
                                    <div className="form-item">
                                        <label htmlFor="edit-field-folder-und">Folder</label>
                                        <select
                                            id="edit-field-folder-und"
                                            name="field_folder"
                                            className="resource-library-form-select"
                                            value={formData.field_folder}
                                            onChange={handleChange}
                                        >
                                            {/* Loop through the folders array and render options dynamically */}
                                            {folders.map((folder) => (
                                            <option key={folder.value} value={folder.value}>
                                                {folder.label}
                                            </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div>
                                        <div>
                                            {showSummary && (
                                                <div className="form-item">
                                                    <label htmlFor="create_summary">
                                                        Summary <span>(<a className="" href="#" onClick={(e) => { e.preventDefault(); setShowSummary(false); }}>Hide Summary</a>)</span>
                                                    </label>
                                                    <>
                                                        {/* <Editor 
                                                            containerProps={{ style: { resize: 'vertical' } }} 
                                                            value={formData.summary} 
                                                            onChange={(value) => setFormData((prev) => ({ ...prev, summary: value }))}
                                                            // onChange={value => onEditorChange('summary', value)}
                                                        /> */}
                                                        <Editor 
                                                        value={formData.summary} 
                                                        onChange={(e) => {
                                                            const newValue = e?.target?.value || '';
                                                            setFormData((prev) => ({ ...prev, summary: newValue }));
                                                        }}
                                                        />
                                                    </>
                                                    <div className="description">Leave blank to use trimmed value of full text as the summary.</div>
                                                </div>
                                            )}
                                    
                                            <div className="form-item">
                                                <label htmlFor="create_body">
                                                    Body 
                                                    {!showSummary && (
                                                        <span>
                                                            (<a href="#" onClick={(e) => { e.preventDefault(); setShowSummary(true); }}>
                                                                Edit Summary
                                                            </a>)
                                                        </span>
                                                    )}
                                                </label>
                                                <>
                                                    {useRichEditor ? (
                                                        <> 
                                                            <Editor 
                                                                containerProps={{ style: { resize: 'vertical', height:'300px' } }} 
                                                                value={formData.body} 
                                                                // onChange={e => onEditorChange('body', e.target.value)}
                                                                // onChange={value => onEditorChange('body', value)}
                                                                onChange={handleEditorChange}

                                                            />  
                                                            <a href="#" onClick={(e) => { e.preventDefault(); setUseRichEditor(false); }}>
                                                                Switch to plain text editor
                                                            </a>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <textarea
                                                                id="create_body"
                                                                rows="20"
                                                                value={formData.body} 
                                                                // onChange={e => onEditorChange('body', e.target.value)}
                                                                onChange={(e) => setFormData((prev) => ({ ...prev, body: e.target.value })) } 
                                                            />
                                                            <div 
                                                                className="grippie" 
                                                                style={{ background: `#eee url("/basic/web/images/grippie.png") no-repeat center 2px` }}
                                                            >
                                                            </div>
                                                            <a href="#" onClick={(e) => { e.preventDefault(); setUseRichEditor(true); }}>
                                                                Switch to rich text editor
                                                            </a>
                                                        </>
                                                    )}
                                                </>
                                            </div>
                                            <div className="form-item">
                                                <label htmlFor="edit-field-url">URL</label>
                                                <input
                                                    className=""
                                                    type="text"
                                                    id="edit-field-url"
                                                    name="field_url"
                                                    value={formData.field_url}
                                                    onChange={handleChange}
                                                    size="60"
                                                    maxLength="60"
                                                />
                                            </div>
                                            <p>File Attachments</p>
                                            <div>
                                                {uploadedFiles.length > 0 && (
                                                    <table className="" style={{fontSize:"14px", width:"90%"}}>
                                                        <thead>
                                                            <tr style={{textAlign:"left"}}>
                                                            <th>File information</th>
                                                            <th>Operations</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody style={{backgroundColor: "#eee", borderBottom: "1px solid #ccc"}}>
                                                            {uploadedFiles.map((file, index) => (
                                                            <tr key={index}>
                                                                <td>
                                                                <span className="file">
                                                                    <img
                                                                        className="file-icon"
                                                                        alt="File icon"
                                                                        src={getFileIcon(file.name)}
                                                                        style={{ marginRight: '8px' }}
                                                                    />
                                                                    <a href={URL.createObjectURL(file)} target="_blank" rel="noreferrer">
                                                                    {file.name}
                                                                    </a>
                                                                </span>
                                                                <span> ({(file.size / 1024).toFixed(2)} KB)</span>
                                                                </td>
                                                                <td>
                                                                <button
                                                                    type="button"
                                                                    className="form-submit"
                                                                    onClick={() => removeFile(index)}
                                                                >
                                                                    Remove
                                                                </button>
                                                                </td>
                                                            </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                )}
                                                {errorMessage && (
                                                    <div 
                                                        className="set-message-error" 
                                                        style={{ 
                                                            background: `#fef5f1 url("/basic/web/images/message-24-error.png") left 10px top 10px no-repeat`, 
                                                            padding: "10px 10px 10px 50px",
                                                            width: "90%",
                                                        }}
                                                    >
                                                        {errorMessage}
                                                    </div>
                                                )}

                                                <div className="form-item" style={{width: "100%"}}>
                                                    <label htmlFor="edit-field-agent-contract">Add a new file</label>
                                                    <div>
                                                        <input
                                                            type="file"
                                                            id="edit-field-agent-contract"
                                                            name="field_file_attachments"
                                                            className="form-file"
                                                            multiple
                                                            onChange={handleFileInputChange}
                                                            key={fileInputKey}
                                                            style={{width:"auto"}}
                                                        />
                                                        <button type="button" onClick={handleUpload} disabled={selectedFiles.length === 0} className="form-submit">
                                                            Upload
                                                        </button>
                                                    </div>
                                                    <div className="description" style={{fontSize:".85em"}}>
                                                        Files must be less than <strong>128 MB</strong>.<br />
                                                        Allowed file types: <strong>txt doc pdf xls docx xlsx csv html htm gif png jpg mp4 mov flv</strong>.
                                                    </div>
                                                </div>

                                            </div>
                                            <div className="form-item">
                                                <label htmlFor="meta_title">Meta Title</label>
                                                <input type="text" id="meta_title" name="field_meta_title" value={formData.field_meta_title} 
                                                onChange={handleChange}  
                                                /> 
                                            </div>
                                            <div className="form-item">
                                                <label htmlFor="meta_keywords">Meta Keywords</label>
                                                <input type="text" id="meta_keywords" name="field_meta_keywords" value={formData.field_meta_keywords} 
                                                    onChange={handleChange}
                                                /> 
                                            </div>
                                            <div className="form-item">
                                                <label>Meta Description</label>
                                                <textarea
                                                    name="field_meta_description"
                                                    value={formData.field_meta_description}
                                                    onChange={handleChange}
                                                    rows={5}
                                                />
                                                <div className="grippie" style={{
                                                background: `#eee url(/basic/web/images/grippie.png) no-repeat center 2px`,
                                                }}>   
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-actions form-wrapper" id="create-actions">
                                        {/* <input type="submit" id="create-submit" name="" value="Save" className="form-submit" />&nbsp;&nbsp; */}
                                        <button type="submit" className="form-submit" disabled={disabled}>{formData.button_name}</button>&nbsp;&nbsp;
                                        <input 
                                            type="button" 
                                            id="edit-preview"  
                                            value="Preview" 
                                            className="form-submit" 
                                            onClick={()=> {
                                            handlePreviewClick();
                                            // window.scrollTo({ top: 0, behavior: 'smooth' });
                                            }}
                                        />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="right">
                        <SalespersonSidebar/>
                    </div>
                </div>
            )}
        </>
    );
};
export default ResourceLibraryCreate;
